import {IChartStop} from '@containers/monitoringPlatform/passengerCharts/types'

export interface IPlacedStop extends IChartStop {
	at: number | null
	estimated: boolean
}

const MAX_GAP_SECONDS = 2 * 60 * 60

export const estimateTerminals = (stops: IChartStop[]): IPlacedStop[] =>
	stops.map((stop, index) => {
		if (stop.realArrival != null) {
			return {...stop, at: stop.realArrival, estimated: false}
		}
		if (!stop.ep) {
			return {...stop, at: null, estimated: false}
		}
		let prevTime: number | null = null
		for (let i = index - 1; i >= 0; i--) {
			const prev = stops[i]
			if (prev.realArrival != null) {
				prevTime = prev.realDeparture ?? prev.realArrival
				break
			}
		}
		const next = stops.slice(index + 1).find((s) => s.realArrival != null)
		if (prevTime == null || !next || next.realArrival! - prevTime >= MAX_GAP_SECONDS) {
			return {...stop, at: null, estimated: false}
		}
		return {...stop, at: Math.round((prevTime + next.realArrival!) / 2), estimated: true}
	})
